var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentStatusUpdateCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2958_26251",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.47 6.47 2 12 2C17.53 2 22 6.47 22 12C22 17.53 17.53 22 12 22C6.47 22 2 17.53 2 12ZM14.8907 16.3007C15.2807 16.6907 15.9107 16.6907 16.3007 16.3007C16.6807 15.9107 16.6807 15.2707 16.3007 14.8907L13.4107 12.0007L16.3007 9.1107C16.6907 8.7207 16.6907 8.0907 16.3007 7.7007C15.9107 7.3107 15.2807 7.3107 14.8907 7.7007L12.0007 10.5907L9.11069 7.7007C8.72069 7.3107 8.09069 7.3107 7.70069 7.7007C7.51344 7.88753 7.4082 8.14119 7.4082 8.4057C7.4082 8.67022 7.51344 8.92387 7.70069 9.1107L10.5907 12.0007L7.70069 14.8907C7.51344 15.0775 7.4082 15.3312 7.4082 15.5957C7.4082 15.8602 7.51344 16.1139 7.70069 16.3007C8.09069 16.6907 8.72069 16.6907 9.11069 16.3007L12.0007 13.4107L14.8907 16.3007Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2958_26251)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#858C94"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentStatusUpdateCancel);
export default __webpack_public_path__ + "static/media/document-status-update-cancel.b068e3e68d7eee93b18f0c0d5a3a3853.svg";
export { ForwardRef as ReactComponent };